module.exports = __webpack_public_path__ + "static/media/1.22cb9fa4.jpg";